<template>
  <section class="section">
    <van-row class="stats-row" align="center">
      <van-col span="6">
        <div class="stat-cell">
          <span class="stat-value">{{ appData.stats[0].value }}</span>
          <div class="stars">
            <van-icon v-for="i in 5" :key="i" name="star" size="7" color="#9ca3af" />
          </div>
          <span class="stat-caption">{{ t('donwload.review') }}</span>
        </div>
      </van-col>
      <van-col span="1"><div class="divider" /></van-col>
      <van-col span="5">
        <div class="stat-cell">
          <span class="stat-value">{{ appData.stats[1].value }}</span>
          <span class="stat-sub">{{ t('appStore.statsYears') }}</span>
          <span class="stat-caption">{{ t('appStore.statsAgeRating') }}</span>
        </div>
      </van-col>
      <van-col span="1"><div class="divider" /></van-col>
      <van-col span="5">
        <div class="stat-cell">
          <span class="stat-value">{{ appData.stats[2].value }}</span>
          <span class="stat-sub">{{ t('download.casino') }}</span>
        </div>
      </van-col>
      <van-col span="1"><div class="divider" /></van-col>
      <van-col span="5">
        <div class="stat-cell">
          <img :src="appData.stats[3].avatar" alt="" class="dev-avatar" />
          <span class="stat-label">{{ t('donwload.appName') }}</span>
          <span class="stat-caption">{{ t('appStore.statsDeveloper') }}</span>
        </div>
      </van-col>
    </van-row>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';

const { t } = useI18n();
</script>

<style scoped>
.section {
  padding: 16px 8px 0;
}

.stats-row {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.stat-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 2px;
}

.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  line-height: 1;
}

.stars {
  display: flex;
  gap: 1px;
  margin-top: 4px;
}

.stat-sub,
.stat-label {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #374151;
}

.stat-caption {
  margin-top: 2px;
  font-size: 10px;
  color: #6b7280;
}

.dev-avatar {
  width: 25px;
  height: 25px;
  border-radius: 8px;
  object-fit: cover;
}

.divider {
  height: 24px;
  border-left: 1px solid #e5e7eb;
  margin: 0 auto;
}
</style>
